import React,{useState} from "react";
import { Link } from "react-router-dom"; 
import { FaFileInvoice, FaGlobe, FaInfoCircle } from 'react-icons/fa';
import {fetchCheckoutUrl} from '../../../api/Services/paymentSevice';
import { fetchCreateProject } from "../../../api/Services/ProjetService";
import { ClipLoader } from "react-spinners";
import { Button, TextField } from "@mui/material";

const CandidateV3Area = () => {
  const [open, setOpen] = useState(false);
  const serviceTypes = ["WEBPACKAGE_ORDER"];
  const [isLoading, setIsLoading] = useState(false);


  const [projectName, setProjectName] = useState(""); 
  const [showError, setShowError] = useState(false);



  const handleSubmit = async () => {
   
    if (!projectName.trim())
     {
    console.log('de');
      
      setShowError(true);
      return;
    }
    setIsLoading(true);

    setShowError(false);
    try {
      const projectResponse = await fetchCreateProject(projectName);

      const checkoutUrl = await fetchCheckoutUrl(projectName, serviceTypes); 

      if (checkoutUrl) {
        window.location.href = checkoutUrl; 
      }
    } catch (error) {
      console.error(error);
      window.location.href = '/login'; 
    }finally{
      setIsLoading(false);

    }
  };

  
  return (
    <>
      <section className="order-section mt-8">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-12">
              <div className="left-section">
                <div className="mb-4">
                  <Link to="/package-com">
                    <span  className="precedent-text">
                      {"< Précédent"}
                    </span>
                  </Link>
                  
                </div>

                <h2 className="section-title mb-4">Votre commande</h2>
                <h3 className="sub-title mb-4">Création d'un package Web</h3>

                <div className="service-info">
                  <table className="pricing-table">
                    <thead>
                      <tr>
                        <th className="service-title">
                          <FaFileInvoice /> Pharos WebPro
                        </th>
                        <th className="pricing-item">
                          49.90 € HT /mois
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan="2">
                          <ul>
                            <li>Un nom de domaine</li>
                            <li>Une adresse mail professionnelle</li>
                            <li>Une boite mail</li>
                            <li>Un site Web sécurisé</li>
                            <li>Un gestionaire électronique de documents (GED)</li>
                        </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-12">
              
              <div className="right-section card mb-4">
                <div className="card-header">
                  <h3>Récapitulatif</h3>
                </div>
                <div className="card-body">
                  <p>Total commande HT: xx €</p>
                  <p>TVA <FaInfoCircle /> : yy €</p>
                  <p>Total TTC: zz €</p>
                  <h4>Nommez votre projet</h4>
                  <TextField
                                  label="Nom du projet"
                                  variant="outlined"
                                  fullWidth
                                  value={projectName}
                                  onChange={(e) => setProjectName(e.target.value)}
                                  error={showError && !projectName.trim()}
                                  helperText={showError && !projectName.trim() ? "Veuillez entrer un nom de projet." : ""}
                                  margin="normal"
                                />

                                <Button
                                  variant="contained"
                                  color="primary"
                                  fullWidth
                                  className="btn-eleven1 fw-500 tran3s d-block mt-3"
                                  onClick={handleSubmit}
                                  disabled={!projectName.trim()}
                                >
                                  {isLoading ? (
                                    <ClipLoader height="20" width="20" color="#fff" ariaLabel="loading" />
                                  ) : (
                                    "Valider"
                                  )}
                                </Button>
                
                  <hr />
                  <p className="note">
                    En fonction du régime TVA que vous aurez choisi, vous pourrez récupérer les frais de TVA via votre future entreprise.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <style jsx>{`
        .order-section {
          padding: 50px 0 0px 0;
        }
       
        .btn-success {
          background-color: #28a745;
          color: #fff;
          border: none;
          padding: 10px 20px;
          font-size: 16px;
        }
        .section-title {
          font-size: 24px;
          font-weight: 600;
          margin: 20px 0;
        }
        .sub-title {
          font-size: 20px;
          font-weight: 400;
          margin: 10px 0;
        }
        .service-info {
          margin-top: 20px;
        }
        .service-title {
          font-size: 18px;
          font-weight: 600;
          margin-top: 20px;
        }
        .service-info ul {
          list-style: disc;
          padding-left: 20px;
        }
        .center-section {
          padding: 20px;
        }
        .btn-primary {
          background-color: #007bff;
          color: #fff;
          border: none;
          padding: 10px 20px;
          font-size: 16px;
          margin-bottom: 20px;
        }
        .pricing-info {
          margin-top: 20px;
        }
     
        .right-section {
          background: #fff;
          padding: 20px;
          border-radius: 5px;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }
        .card-header {
          border-bottom: 1px solid #ddd;
          padding-bottom: 10px;
          margin-bottom: 10px;
        }
        .card-body {
          padding-top: 10px;
        }
        .note {
          font-size: 0.875rem;
          color: #666;
        }
        .card-header h3 {
          margin: 0;
        }
       
        .card-body hr {
          margin: 20px 0;
        }
          .left-section {
  padding: 20px;
}
/* partie ajoute */ 
.btn-group {
  display: flex;
  gap: 450px; 
}

.section-title {
  margin-top: 20px;
  margin-bottom: 10px;
}

.sub-title {
  margin-bottom: 20px;
}

.pricing-table {
  width: 100%;
  margin-bottom: 20px;
}

.service-title {
  text-align: left;
  padding: 10px 15px;
}

.pricing-item {
  text-align: right;
  padding: 10px 15px;
}

ul {
  padding-left: 20px;
}

ul li {
  margin-bottom: 10px;
}

          
      `}</style>
    </>
  );
};

export default CandidateV3Area;
